import React, { useEffect, useState, useRef, useCallback } from 'react'
import { FormattedDate, FormattedTime } from 'react-intl'
import { Button, MarkdownTextArea, MarkdownViewer } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'

const Chat = ({ messages: _messages, onSend: _onSend }) => {
  const threadRef = useRef(null)
  const [messages, setMessages] = useState([])
  const [inputValue, setInputValue] = useState('')

  useEffect(() => setMessages(_messages), [_messages])

  useEffect(() => {
    if (threadRef.current) {
      threadRef.current.scrollTop = threadRef.current.scrollHeight
    }
  }, [messages])

  const onSend = useCallback(() => {
    const markdown = inputValue.trim()

    if (!markdown.length) {
      return window.alert('Message is empty!')
    }

    const nextMessage = {
      id: +Date.now(),
      timestamp: Math.floor(Date.now() / 1000),
      body: markdown,
      recipient: { type: 4 },
    }

    setMessages((prevMessages) => [...prevMessages, nextMessage])
    setInputValue('')

    _onSend(markdown)
  }, [_onSend, inputValue])

  return (
    <div className="w-full h-full flex flex-col">
      <div className="grow overflow-y-auto p-4 space-y-4" ref={threadRef}>
        {messages.map(({ id, timestamp, body, recipient }) => (
          <div
            key={id}
            className={classNames(
              'flex',
              recipient?.type > 1 ? 'justify-end' : 'justify-start'
            )}
          >
            <div className="w-2/3">
              <div
                tabIndex={0}
                className={classNames(
                  'break-words cursor-pointer focus:border-primary-darker focus:max-h-full focus:outline-none focus:ring max-h-48 overflow-hidden p-4 rounded-md shadow-sm text-sm whitespace-pre-wrap',
                  recipient?.type > 1
                    ? 'bg-secondary-darker hover:bg-secondary text-white'
                    : 'bg-gray-200 hover:bg-gray-300'
                )}
              >
                <MarkdownViewer>
                  {body}
                </MarkdownViewer>
              </div>
              <div className="text-xs mt-1 w-full text-right px-1 text-gray-500 space-x-1">
                {timestamp > 0 ? (
                  <>
                    <span>
                      <FormattedDate value={new Date(timestamp * 1000)} />
                    </span>
                    <span>
                      <FormattedTime value={new Date(timestamp * 1000)} />
                    </span>
                  </>
                ) : (
                  <span>Unknown</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="p-4 flex justify-end">
        <div className="w-2/3">
          <MarkdownTextArea
            value={inputValue}
            onChange={(setInputValue)}
          />

          <div className="text-right mt-2">
            <Button
              variant={inputValue?.length ? 'solid' : 'outline'}
              size='sm'
              disabled={!inputValue?.length}
              onClick={onSend}
            >
              Send
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Chat
